<div class="flex min-h-screen bg-[var(--bg-soft)] text-slate-800 relative">
  <!-- Mobile overlay -->
  @if (!isDesktop && mobileOpen) {
    <div
      class="fixed inset-0 bg-black/30 backdrop-blur-sm z-30 lg:hidden"
      (click)="toggleSidebar()"
      aria-hidden="true"
    ></div>
  }

  <!-- Sidebar -->
  <aside
    class="sidebar-surface text-white flex flex-col fixed inset-y-0 left-0 z-40 transform transition-transform duration-200"
    [class.-translate-x-full]="!isDesktop && !mobileOpen"
    [style.width.px]="asideWidth"
  >
    <!-- Brand header -->
    <div class="flex items-center px-5 py-4 gap-3 border-b border-white/10">
      <span class="pi pi-shield text-xl text-sky-100"></span>
      @if (!collapseCompact) {
        <div class="leading-tight">
          <p class="text-xs uppercase text-white/60 tracking-wide">{{ 'shell.adminLabel' | translate }}</p>
          <p class="font-semibold">{{ 'shell.brandName' | translate }}</p>
        </div>
      }
    </div>

    <!-- Navigation -->
    <nav class="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
      @for (item of menu; track item.label) {
        <a
          [routerLink]="item.path"
          routerLinkActive="menu-link-active"
          class="flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition hover:bg-white/10 hover:text-white"
          (click)="handleNavClick()"
          [pTooltip]="item.label | translate"
          tooltipStyleClass="menu-tooltip"
          tooltipPosition="right"
          [tooltipDisabled]="!collapseCompact"
        >
          <i [class]="item.icon"></i>
          @if (!collapseCompact) {
            <span class="flex-1">{{ item.label | translate }}</span>
          }
          @if (item.badge) {
            <span class="text-xs bg-white/20 px-2 py-0.5 rounded-full">{{ item.badge }}</span>
          }
        </a>
      }
    </nav>

    <!-- User footer -->
    @if (!collapseCompact) {
      <div class="px-4 py-4 border-t border-white/10">
        <div class="flex items-center gap-3 mb-3">
          <p-avatar [label]="userInitials" shape="circle" styleClass="bg-white/10"></p-avatar>
          <div class="text-sm leading-tight min-w-0 flex-1">
            <p class="font-semibold truncate">{{ userName }}</p>
            <p class="text-white/70 truncate text-xs">{{ userRole }}</p>
          </div>
        </div>
        <button
          pButton
          type="button"
          icon="pi pi-sign-out"
          class="p-button-text p-button-sm w-full text-white/80 hover:text-white"
          [label]="'actions.logout' | translate"
          (click)="logout()"
        ></button>
      </div>
    } @else {
      <div class="px-4 py-4 border-t border-white/10 flex flex-col items-center gap-2">
        <p-avatar [label]="userInitials" shape="circle" styleClass="bg-white/10"></p-avatar>
        <button
          pButton
          type="button"
          icon="pi pi-sign-out"
          class="p-button-text p-button-rounded p-button-sm text-white/80"
          [pTooltip]="'actions.logout' | translate"
          tooltipPosition="right"
          (click)="logout()"
        ></button>
      </div>
    }
  </aside>

  <!-- Main content -->
  <div class="flex-1 flex flex-col" [style.marginLeft.px]="contentMargin">
    <!-- Top header bar -->
    <header
      class="h-14 sm:h-16 bg-white border-b border-[var(--border)] px-2 sm:px-5 lg:px-6 flex items-center justify-between gap-2 sm:gap-3 shadow-sm"
    >
      <div class="flex items-center gap-1 sm:gap-3 text-xs sm:text-sm text-slate-600 min-w-0 flex-1">
        <button
          pButton
          type="button"
          class="p-button-text p-button-rounded p-button-sm"
          icon="pi pi-bars"
          (click)="toggleSidebar()"
          [attr.aria-expanded]="toggleExpanded"
          [attr.aria-label]="'shell.toggleMenu' | translate"
        ></button>
        <span class="text-brand-700 font-semibold truncate">{{ 'shell.brandName' | translate }}</span>
        <span class="text-slate-400 hidden sm:inline">/</span>
        <span class="hidden sm:inline truncate">{{ currentPageLabel | translate }}</span>
      </div>
      <div class="flex items-center gap-2 sm:gap-3 flex-shrink-0">
        <button
          pButton
          icon="pi pi-bell"
          class="p-button-text p-button-rounded p-button-sm lg:p-button"
          pBadge
          value="0"
        ></button>
        <p-avatar [label]="userInitials" shape="circle" styleClass="shadow-sm"></p-avatar>
      </div>
    </header>

    <!-- Page content -->
    <main class="p-3 sm:p-4 md:p-6">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
